import { IGatsbyImageData } from 'gatsby-plugin-image';

import { assetUrl } from './assets';

/**
 * A very simple funcion to check if an image is a gif, by checking if the
 * string '.gif' appears in the image url.
 */
const imageIsGif = (url: string) => url.toLowerCase().match(/\.(gif)/g);

export const drupalImageData = (
  image: ImageFragment,
  preset: 'teaser' | 'content' | 'hero',
  sizes: string = '(min-width: 430px): 768px',
) => {
  const styles = image.styles
    .filter((style) => style.id === preset)
    .map((style) => style.sources)[0];

  if (!styles || styles.length === 0 || (image.url && imageIsGif(image.url))) {
    return {
      backgroundColor: '#CCC',
      height: image.height,
      width: image.width,
      layout: 'constrained',
      images: {
        fallback: {
          src: assetUrl(image.url || ''),
        },
      },
    } as IGatsbyImageData;
  }

  const largest = styles.sort((a, b) => (a.width > b.width ? 1 : -1))[
    styles.length - 1
  ];
  return {
    backgroundColor: '#CCC',
    height: largest.height,
    width: largest.width,
    layout: 'constrained',
    images: {
      fallback: {
        src: assetUrl(largest.url),
        sizes,
        srcSet: styles
          .map((style) => `${assetUrl(style.url)} ${style.width}w`)
          .join(', '),
      },
    },
  } as IGatsbyImageData;
};
